var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.24 38.4c220.56 0 399.36 178.8 399.36 399.36s-178.8 399.36-399.36 399.36c-220.56 0-399.36-178.8-399.36-399.36s178.8-399.36 399.36-399.36zM522.24-2.56c-243.182 0-440.32 197.138-440.32 440.32s197.138 440.32 440.32 440.32c243.182 0 440.32-197.138 440.32-440.32s-197.138-440.32-440.32-440.32zM698.366 613.888h-352.254v-170.62h352.254v170.62zM346.112 406.404v-52.304h352.255v52.304h-352.255zM503.809 267.686v49.55h-176.129c-10.18 0-18.432 8.252-18.432 18.432v296.652c0 10.18 8.252 18.432 18.432 18.432h389.118c10.18 0 18.432-8.252 18.432-18.432v-296.653c0-10.18-8.252-18.431-18.432-18.431h-176.124v-49.55h109.509c24.576 0 24.576-36.864 0-36.864h-255.887c-24.576 0-24.576 36.864 0 36.864h109.515z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.985be8e17c50064516f6ff67ebd92184.svg";
export { ForwardRef as ReactComponent };